import { render, staticRenderFns } from "./characterStoryInfo.vue?vue&type=template&id=60a4130b&scoped=true"
import script from "./characterStoryInfo.vue?vue&type=script&lang=js"
export * from "./characterStoryInfo.vue?vue&type=script&lang=js"
import style0 from "./characterStoryInfo.vue?vue&type=style&index=0&id=60a4130b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a4130b",
  null
  
)

export default component.exports